import { gql } from 'apollo-angular';

const GET_SUPPLIERS = gql`
  query organization($parentCompanyId: Long!) {
    organization(id: $parentCompanyId) {
      id
      name
      children {
        id
        name
      }
    }
  }
`;

export default GET_SUPPLIERS;
